var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-filter"},[_c('div',{staticClass:"main-filter-search"},[_c('search-component')],1),_c('div',{staticClass:"main-filter-group"},[_c('filter-list',{attrs:{"filter-array":_vm.testArray1}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }